import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalStore } from "./store";
import { initialize } from "@sumologic/opentelemetry-rum";

interface InitializeOptions {
  collectionSourceUrl: string;
  serviceName: string;
  deploymentEnvironment: string;
  applicationName: string;
  propagateTraceHeaderCorsUrls: any;
}

initialize({
  collectionSourceUrl: process.env.REACT_APP_SUMOLOGIC_COLLECTION_SOURCE_URL,
  serviceName: process.env.REACT_APP_SUMOLOGIC_COLLECTION_SERVICE_NAME,
  deploymentEnvironment: process.env.REACT_APP_SUMOLOGIC_COLLECTION_DEPLOYMENT_ENVIRONMENT,
  applicationName: process.env.REACT_APP_SUMOLOGIC_COLLECTION_APPLICATION_NAME,
  samplingProbability: 1,
  collectErrors: true,
  propagateTraceHeaderCorsUrls: process.env.REACT_APP_SUMOLOGIC_COLLECTION_API_URL
} as InitializeOptions);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalStore>
      <Router>
        <App />
      </Router>
    </GlobalStore>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
